import { useQuery } from '@tanstack/react-query';
import { getCurrentUserDetails } from '../api/users.api';
import { CURRENT_USER_QUERY_KEY } from '../config/user-query-keys';
import { userHasAdminAccess } from '../lib/user-has-admin-access';
import { userIsExternal, userIsInternal } from '../lib/user-is-external';
import { useAuth } from '@/shared/components/auth/AuthProvider';

/**
 * Fetches current user details from basecamp (includes roles).
 * Only runs when user is authenticated.
 */
export function useCurrentUserDetails() {
    const { user } = useAuth();

    const { data, isLoading, error } = useQuery({
        queryKey: [...CURRENT_USER_QUERY_KEY, user?.uid],
        queryFn: getCurrentUserDetails,
        enabled: !!user?.uid,
        staleTime: 5 * 60 * 1000, // 5 min
    });

    const isAdmin = data ? userHasAdminAccess(data.user) : false;
    const isExternalUser = userIsExternal(data?.user);
    const isInternalUser = userIsInternal(data?.user);

    return {
        userDetails: data,
        user: data?.user,
        isAdmin,
        isExternalUser,
        isInternalUser,
        isLoading,
        error,
    };
}
